/* eslint-disable jsx-a11y/control-has-associated-label */
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import "./myScroll.scss";

export default function MyScroll({
  children,
  theme = "light",
  scrollEndOnItemAdd = true,
}) {
  const scrollDivRef = useRef(null);
  const [leftDisabled, setLeftDisabled] = useState(false);
  const [rightDisbaled, setRightDisbaled] = useState(false);
  const [showButtons, setShowButtons] = useState(false);

  const handleScroll = (direction) => {
    let scrollAmount = scrollDivRef.current?.scrollLeft;
    const w = Math.round(scrollDivRef.current.getBoundingClientRect().width);
    const s = scrollDivRef.current.scrollWidth;
    const scrollStep = Math.floor((w / 4) * 3);
    if (direction === "right" && scrollAmount <= w + scrollStep) {
      scrollAmount = Math.min(s - w, scrollAmount + scrollStep);
    } else if (direction === "left" && scrollAmount > 0) {
      scrollAmount = Math.max(0, scrollAmount - scrollStep);
    }
    scrollDivRef.current.scroll({
      left: scrollAmount,
      behavior: "smooth",
    });
  };

  const updateButtonStates = () => {
    setShowButtons(
      scrollDivRef.current?.scrollWidth -
        Math.round(scrollDivRef.current?.getBoundingClientRect().width)
    );
    setLeftDisabled(scrollDivRef.current?.scrollLeft === 0);
    setRightDisbaled(
      scrollDivRef.current?.scrollWidth ===
        Math.round(scrollDivRef.current?.getBoundingClientRect().width) ||
        scrollDivRef.current?.scrollLeft ===
          scrollDivRef.current?.scrollWidth -
            Math.round(scrollDivRef.current?.getBoundingClientRect().width)
    );
  };

  useEffect(() => {
    if (scrollDivRef) {
      updateButtonStates();
    }
    window.addEventListener("resize", updateButtonStates);
    return () => window.removeEventListener("resize", updateButtonStates);
  }, [scrollDivRef]);

  useEffect(() => {
    if (scrollEndOnItemAdd) {
      const scrollAmount =
        scrollDivRef.current?.scrollWidth -
        Math.round(scrollDivRef.current?.getBoundingClientRect().width);
      scrollDivRef.current.scroll({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  }, [children]);

  return (
    <div className="row align-items-center">
      {!!showButtons && (
        <div className="col-auto">
          <button
            type="button"
            className={`btn scroll-left ${
              theme === "light" ? "text-white" : "btn-outline-secondary"
            } border-0`}
            onClick={() => {
              handleScroll("left");
            }}
            disabled={leftDisabled}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
        </div>
      )}
      <div
        className="col overflow-scroll my-scroll"
        ref={scrollDivRef}
        onScroll={(e) => {
          e.stopPropagation();
          updateButtonStates();
        }}
      >
        {children}
      </div>
      {!!showButtons && (
        <div className="col-auto">
          <button
            type="button"
            className={`btn scroll-right ${
              theme === "light" ? "text-white" : "btn-outline-secondary"
            } border-0`}
            onClick={() => {
              handleScroll("right");
            }}
            disabled={rightDisbaled}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      )}
    </div>
  );
}
